import { Wizard } from './Wizard';
import { NextButton, PrevButton } from './WizardButtons';
import { WizardStep } from './WizardStep';
var WizardComponent = Object.assign(Wizard, {
    Step: WizardStep,
    NextButton: NextButton,
    PrevButton: PrevButton,
});
export default WizardComponent;
